import React from 'react';
import { motion } from 'framer-motion';

export default function ProductCard({ product, onAddToCart }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="group cursor-pointer flex flex-col"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-smoke-lighter mb-5">
        <div className="absolute top-4 left-4 z-20 flex flex-col gap-2">
          {product.isNew && (
            <span className="bg-linen text-smoke text-[9px] font-bold tracking-[0.2em] uppercase px-3 py-1.5 shadow-xl">
              New
            </span>
          )}
          {product.bestseller && (
            <span className="bg-ember text-linen text-[9px] font-bold tracking-[0.2em] uppercase px-3 py-1.5 shadow-xl">
              Bestseller
            </span>
          )}
        </div>

        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110 opacity-80 group-hover:opacity-100"
        />
        
        <div className="absolute inset-0 bg-smoke/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 backdrop-blur-[2px]">
          <button 
            onClick={(e) => { e.stopPropagation(); onAddToCart(); }}
            className="px-8 py-3.5 bg-linen text-smoke font-bold text-[11px] hover:bg-ember hover:text-linen transition-all duration-300 uppercase tracking-[0.2em] transform translate-y-4 group-hover:translate-y-0 shadow-2xl"
          >
            Add to Cart — ${product.price.toFixed(2)}
          </button>
        </div>
      </div>

      <div className="flex flex-col space-y-1.5 px-1">
        <div className="flex justify-between items-baseline">
          <h3 className="font-serif text-xl text-linen/90 group-hover:text-linen transition-colors">{product.name}</h3>
          <span className="text-linen/40 font-medium text-sm group-hover:text-ember transition-colors">${product.price.toFixed(2)}</span>
        </div>
        <div className="flex items-center space-x-3">
          <span className="text-[10px] text-ember/80 font-bold uppercase tracking-[0.15em]">{product.family}</span>
          <span className="w-1 h-1 rounded-full bg-white/10"></span>
          <span className="text-xs text-linen/40 italic font-serif truncate">{product.notes}</span>
        </div>
      </div>
    </motion.div>
  );
}